













































































































































































































































































































































































































































































































































































































































































import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import translationsService from "@/services/translations";
import FilePreviewPopup from "@/views/filepreview/FilePreviewPopup.vue";
import {
  DictionariesModel,
  DictionaryModel
} from "../../models/dictionary.model";
import { env } from "@/env";
import VueI18n from "@/i18n";
import { Model } from "@/models/model.model";

const TranslateStore = namespace("translate");
const ModelStore = namespace("model");
const DictionaryStore = namespace("dictionaries");

@Component({
  name: "TranslateComponent",
  components: {
    FilePreviewPopup
  }
})
export default class TranslateComponent extends Vue {
  @TranslateStore.Getter
  public getTranslateFromLanguages!: any[];
  @TranslateStore.Getter
  public getTranslateFromFilteredLanguages!: (model: string) => any[];
  @TranslateStore.Getter
  public getTranslateToLanguages!: any[];
  @TranslateStore.Getter
  public getTranslateToFilteredLanguages!: (model: string) => any[];
  @TranslateStore.Getter
  public getUploadedFiles!: any[];
  @TranslateStore.Getter
  public getTranslatedFiles!: any[];
  @TranslateStore.Getter
  public isTranslationCompleted!: boolean;
  @TranslateStore.Getter
  public isFetchingLanguages!: boolean;
  @TranslateStore.Getter
  public isUploadingFiles!: boolean;
  @TranslateStore.Getter
  public isTranslatingFiles!: boolean;
  @DictionaryStore.Getter
  public getDictionaryLanguages!: DictionariesModel;
  @DictionaryStore.Getter
  public isFetchingDictionaries!: boolean;
  @TranslateStore.Action
  public fetchLanguages!: () => Promise<any>;
  @TranslateStore.Action
  public uploadFilesToTranslate!: (payload: any) => Promise<void>;
  @TranslateStore.Action
  public resetState!: () => void;
  @DictionaryStore.Action
  public fetchDictionaries!: () => Promise<any>;
  @DictionaryStore.Action
  public resetDictionariesState!: () => void;
  @ModelStore.Action
  public fetchModels!: () => Promise<any>;
  @ModelStore.Getter
  public getModels!: Model[];
  @ModelStore.Getter
  public isFetchingModels!: boolean;

  private validatedForm: boolean;
  private validatedUrlForm: boolean;
  private files: File[] = [];
  private selectedFromLanguage: string;
  private selectedToLanguage: string;
  private selectedModel: string;
  private dialogMessage: string;
  private snackbarText: string;
  private showMessage: boolean;
  private messageColor: string;
  private isError: boolean;
  private filePreview: {
    show: boolean;
    documentId: string;
    target: string;
    fileName: string;
  };
  private selectedDictionary: DictionaryModel[] = [];
  private selectedDictionaryByFile: DictionaryModel[] = [];
  private getDictionaries: DictionaryModel[] = [];
  private generalDictionary: DictionaryModel;
  private allowedFiles: string;
  private allowedImgFiles: string;
  private queueShowDialog: boolean;
  private strUrl: string;
  private maxFilesRules: {
    maxFiles: number;
    maxFileMb: number;
    maxTotalFilesMb: number;
  };
  private isUploadingUrlFiles: boolean;
  private tabSelected: number;
  private overlay: boolean;

  private readonly RTL_LANGUAGES = ["ar", "he", "fa", "ur"];

  constructor() {
    super();
    this.validatedForm = false;
    this.validatedUrlForm = false;
    this.generalDictionary = {
      workspaceName: "General",
      projectDescription: "This is the description of the project General",
      sourceLanguage: "",
      targetLanguage: "",
      workspaceId: "",
      projectId: "",
      categoryId: ""
    };
    this.files = [];
    this.selectedFromLanguage = "none";
    this.selectedToLanguage = "none";

    this.selectedModel = "cognitive";
    this.dialogMessage = "";
    this.snackbarText = "";
    this.showMessage = false;
    this.messageColor = "";
    this.isError = false;
    this.filePreview = {
      show: false,
      documentId: "-1",
      target: "",
      fileName: ""
    };
    this.selectedDictionary = [];
    this.selectedDictionaryByFile = [];
    this.getDictionaries = [];
    this.allowedFiles =
      ".doc,.docx,.ppt,.pptx,.xls,.xlsx,.xltm,.txt,.text,.htm,.html,.pdf,.srt,.json,.hocr,.msg,.xlf";
    this.allowedImgFiles = ".jpg,.jpeg,.png,.gif,.tif,.tiff";
    this.queueShowDialog = false;
    this.strUrl = "";
    this.maxFilesRules = {
      maxFiles: env.maxFiles,
      maxFileMb: env.maxFileMb,
      maxTotalFilesMb: env.maxTotalFilesMb
    };
    this.isUploadingUrlFiles = false;
    this.overlay = false;
    this.tabSelected = 0;
  }

  public handleFilesUpload(fs: File[]): void {
    const uploadedFiles = fs;
    let validFiles = false;
    let file: File;
    for (file of uploadedFiles) {
      if (this.getValidateFile(file)) {
        (file as any).selectedDictionary = this.selectedDictionary;
        (file as any).ApplyOcr = this.mustApplyOcr(file);
        this.onDictionaryCheckboxChanged(false, file);
        this.files.push(file);
      } else {
        validFiles = true;
      }
    }
    if (validFiles) {
      this.displayInfo(
        "Some files were already selected or are not supported for translation",
        "error"
      );
    }
  }

  public async addUrl(): Promise<void> {
    this.isUploadingUrlFiles = true;
    if (this.validateUrl(this.strUrl)) {
      this.dialogMessage = "Loading file from URL";
      const fileInfo = await translationsService.getFileInfoFromUrl(
        this.strUrl
      );
      if (fileInfo && fileInfo.size > 1) {
        if (fileInfo.size / 1024 < this.maxFilesRules.maxFileMb * 1024) {
          const file: File[] = [
            await translationsService.getFileFromUrl(fileInfo.name, this.strUrl)
          ];
          this.handleFilesUpload(file);
        } else {
          this.displayInfo(
            `${VueI18n.t("You can upload documents up to")} ${
              this.maxFilesRules.maxFileMb
            }${VueI18n.t("mb size each")}`,
            "error"
          );
        }
      } else {
        this.displayInfo("The file from link is not valid", "error");
      }
    } else {
      this.displayInfo("Please enter a valid link", "error");
    }
    this.isUploadingUrlFiles = false;
  }

  public validateUrl(strUrl: string): any {
    try {
      const url = new URL(strUrl);
      return (
        url.protocol === "http:" ||
        url.protocol === "https:" ||
        "Please enter a valid link"
      );
    } catch (error) {
      return "Please enter a valid link";
    }
  }

  public dropHandler(ev: DragEvent): void {
    if (ev.dataTransfer !== null && ev.dataTransfer.items) {
      this.handleFilesUpload([...ev.dataTransfer.files]);
    }
  }

  public async submitFiles(): Promise<void> {
    if (this.isValidForm()) {
      if (this.files.length <= this.maxFilesRules.maxFiles) {
        let bError = false;
        let sumSize = 0;
        this.files.forEach((file: any) => {
          sumSize = sumSize + Math.ceil(file.size / 1024);
          if (
            Math.ceil(file.size / 1024) >=
            this.maxFilesRules.maxFileMb * 1024
          ) {
            bError = true;
          }
        });
        if (sumSize <= this.maxFilesRules.maxTotalFilesMb * 1024 && !bError) {
          this.dialogMessage = "Uploading files, please wait ...";
          await this.uploadFilesToTranslate({
            files: this.files,
            fromLanguage: this.selectedFromLanguage,
            toLanguage: this.selectedToLanguage,
            model: this.selectedModel
          });
          this.queueShowDialog = true;
          this.dialogMessage =
            "You will be notified by email when translation(s) are ready";
          this.files = [];
          (this.$refs.myfiles as any).value = "";
        } else {
          if (bError) {
            this.displayInfo(
              `${VueI18n.t("You can upload documents up to")} ${
                this.maxFilesRules.maxFileMb
              }${VueI18n.t("mb size each")}`,
              "error"
            );
          } else {
            this.displayInfo(
              `${VueI18n.t("You can only upload documents up to a total of")} ${
                this.maxFilesRules.maxTotalFilesMb
              }${VueI18n.t("mb size")}`,
              "error"
            );
          }
        }
      } else {
        this.displayInfo(
          `${VueI18n.t("You can only upload")} ${
            this.maxFilesRules.maxFiles
          } ${VueI18n.t("documents per request")}`,
          "error"
        );
      }
    }
  }

  private removeFile(file: any) {
    const index = this.files.indexOf(file);
    this.files.splice(index, 1);
  }

  private setSelectedModel(model: string) {
    const msg = this.getModels.find(m => {
      return m.model === model;
    });
    if (msg?.message) {
      this.displayInfo(msg.message + ". Please select another one.", "");
      this.selectedModel = "";
    } else {
      this.selectedModel = model;
    }
  }

  private setSelectedFromLanguage(language: string) {
    this.selectedFromLanguage = language.split("|clone")[0];
    this.setDictionaryLanguage(
      this.selectedFromLanguage,
      this.selectedToLanguage
    );
    if (this.RTL_LANGUAGES.indexOf(this.selectedFromLanguage) >= 0) {
      this.displayInfo(
        "RTL language: only text in Word documents is translated"
      );
    }
  }

  private setSelectedToLanguage(language: string) {
    this.selectedToLanguage = language.split("|clone")[0];
    this.setDictionaryLanguage(
      this.selectedFromLanguage,
      this.selectedToLanguage
    );
  }

  private setSelectedDictionary(selectedDictionary: any) {
    this.selectedDictionary = selectedDictionary;

    this.files.forEach((f: any) => {
      this.setSelectedFileDictionary(selectedDictionary, f);
    });
  }

  private setSelectedFileDictionary(selectedDictionary: any, file: any): any {
    file.selectedDictionary = selectedDictionary;
    return selectedDictionary;
  }

  private setDictionaryLanguage(languageFrom: string, languageTo: string) {
    const stringLook: string = "(" + languageFrom + ", " + languageTo + ")";
    this.getDictionaries = (this.getDictionaryLanguages
      .dictionariesByLanguagePair as any)[stringLook];
    if (
      this.getDictionaries &&
      !this.getDictionaries.includes(this.generalDictionary)
    ) {
      this.getDictionaries.unshift(this.generalDictionary);
    } else if (!this.getDictionaries) {
      this.getDictionaries = [this.generalDictionary];
    }
    this.setSelectedDictionary(this.findSgsDictionary());
  }

  private async downloadFile(
    documentId: string,
    fileName: string,
    target: string
  ) {
    this.displayInfo("Downloading translated document, please wait ...", "");
    try {
      const downloaded = await translationsService.downloadFile(
        documentId,
        fileName,
        target
      );
      if (downloaded) {
        this.displayInfo("File downloaded", "");
      } else {
        throw new Error("download failed");
      }
    } catch (error: any) {
      this.displayInfo(
        "There was an error downloading this document, please try again",
        error
      );
    }
  }

  private async previewFile(
    documentId: string,
    fileName: string,
    target: string
  ) {
    this.filePreview.documentId = documentId;
    this.filePreview.fileName = fileName;
    this.filePreview.target = target;
    this.filePreview.show = true;
  }

  private showFile(fileName: string, translationStatus: boolean): boolean {
    const fileNameExtension: string = this.getFileExtension(fileName);
    if (fileNameExtension === "json") {
      return fileNameExtension === "json" && translationStatus;
    } else if (fileNameExtension === "hocr") {
      return fileNameExtension === "hocr" || translationStatus;
    } else {
      return translationStatus;
    }
  }

  private displayInfo(text: string, error = "") {
    this.snackbarText = text;
    this.messageColor = error ? "error" : "sgsOrange";
    this.showMessage = true;
    this.isError = error.length > 0 ? true : false;
    if (error) console.error(text, error);
  }

  private mounted() {
    this.dialogMessage = "Getting available languages for the translation";
    this.resetState();
    this.fetchModels().catch((error: any) => {
      this.displayInfo(
        "Error fetching available models, please check your network connection",
        error
      );
    });
    if (this.getTranslateFromLanguages.length === 0) {
      this.fetchLanguages().catch((error: any) => {
        this.displayInfo(
          "Error fetching available languages, please check your network connection",
          error
        );
      });
    }
    this.resetDictionariesState();
    if (
      (this.getDictionaryLanguages.dictionariesByLanguagePair as any).length ===
      0
    ) {
      this.fetchDictionaries()
        .then(() => {
          this.setDictionaryLanguage(
            this.selectedFromLanguage,
            this.selectedToLanguage
          );
        })
        .catch((error: any) => {
          this.displayInfo(
            "Error fetching available dictionaries, please check your network connection",
            error
          );
        });
    }
  }

  private canApplyOcr(file: File): boolean {
    return (
      file &&
      (this.allowedImgFiles.includes(this.getFileExtension(file.name)) ||
        file.name.toLowerCase().endsWith(".pdf") ||
        file.name.toLowerCase().includes(".doc") ||
        file.name.toLowerCase().includes(".docx"))
    );
  }

  private mustApplyOcr(file: File): boolean {
    return (
      file && this.allowedImgFiles.includes(this.getFileExtension(file.name))
    );
  }

  get canShowDialog(): boolean {
    return (
      this.isFetchingLanguages ||
      this.isFetchingDictionaries ||
      this.isUploadingFiles ||
      this.isUploadingUrlFiles
    );
  }

  get useMultipleDictionaries(): boolean {
    return env.useMultipleDictionaries as boolean;
  }

  get isTranslateEnabled(): boolean {
    return (
      this.files.length >= 1 &&
      !!this.selectedToLanguage &&
      this.selectedModel !== "" &&
      this.selectedFromLanguage !== "none" &&
      this.selectedToLanguage !== "none" &&
      this.selectedToLanguage != this.selectedFromLanguage
    );
  }

  private swapLanguages() {
    if (
      this.selectedFromLanguage !== "" &&
      this.selectedFromLanguage !== this.selectedToLanguage
    ) {
      const swap = this.selectedFromLanguage;
      this.selectedFromLanguage = this.selectedToLanguage;
      this.selectedToLanguage = swap;
      this.setDictionaryLanguage(
        this.selectedFromLanguage,
        this.selectedToLanguage
      );
      if (this.RTL_LANGUAGES.indexOf(this.selectedFromLanguage) >= 0) {
        this.displayInfo(
          "RTL language: only text in Word documents is translated"
        );
      }
    }
  }

  private docIcon(fileName: string) {
    let fileNameExtension = this.getFileExtension(fileName);
    if (fileNameExtension.endsWith("x")) {
      fileNameExtension = fileNameExtension.substring(0, 3);
    }
    if (this.allowedImgFiles.includes(fileNameExtension))
      fileNameExtension = "img";
    try {
      return require(`../../assets/images/${fileNameExtension}-icon.svg`);
    } catch (error) {
      return require(`../../assets/images/unknown-icon.svg`);
    }
  }

  private getFileExtension(fileName: string): string {
    const re: any = /(?:\.([^.]+))?$/;
    let fileNameExtension = "";
    if (fileName) {
      fileNameExtension = re.exec(fileName.toLowerCase())[1] || "";
    }
    return fileNameExtension;
  }

  private getValidateFile(fileToValidate: File): boolean {
    const fileNameExtension: string = this.getFileExtension(
      fileToValidate.name
    );

    if (fileNameExtension === "" || fileNameExtension.length <= 2) {
      return false;
    } else if (
      !this.allowedFiles.includes(fileNameExtension) &&
      !this.allowedImgFiles.includes(fileNameExtension)
    ) {
      return false;
    } else {
      let f: File;
      for (f of this.files) {
        if (f.name === fileToValidate.name) {
          return false;
        }
      }
    }

    return true;
  }

  @Watch("isTranslationCompleted")
  private onTranslationCompleted(ev: boolean) {
    if (ev) {
      this.files = [];
      (this.$refs.myfiles as any).value = "";
    }
  }

  private findSgsDictionary(): DictionaryModel {
    if (this.getDictionaries.length === 0) {
      return this.generalDictionary;
    }
    let customDictionary = this.getDictionaries[0];
    if (this.getDictionaries.length > 1) {
      const sgsDict = this.getDictionaries.filter((d: any) =>
        d.workspaceName.toLowerCase().includes("sgs")
      )[0];
      customDictionary = sgsDict || customDictionary;
    }
    return customDictionary;
  }

  private onDictionaryCheckboxChanged(ev: boolean, file: File) {
    const dictionary = ev ? this.findSgsDictionary() : this.generalDictionary;
    this.setSelectedFileDictionary(dictionary, file);
  }

  private onTabChange(): void {
    if (
      (Vue.prototype.isOldEdge() || !Vue.prototype.isChrome()) &&
      this.tabSelected === 1
    ) {
      this.$nextTick(() => {
        this.tabSelected = 0;
        this.overlay = !this.overlay;
      });
    }
  }

  private isValidForm(): boolean {
    return (this.$refs.form as Vue & { validate: () => boolean }).validate();
  }

  private isValidUrlForm(): boolean {
    return (
      (this.$refs.formUrl as Vue & { validate: () => boolean }).validate() &&
      this.validateUrl(this.strUrl) === true
    );
  }
}
